const isStyleWrapper = (componentName) =>
  componentName.includes('@StyleWrapper');

// Wraps custom prop validators to allow for chaining of `.isRequired`
export default function createCustomPropType(validate) {
  // Disabling the lint rule because this is the function API
  // of react / the prop-types package
  // eslint-disable-next-line max-params
  const checkType = (isRequired, props, propName, componentName) => {
    // Ignore StyleWrapper since it contains all the props of it's children
    if (isStyleWrapper(componentName)) {
      return false;
    }

    if (props[propName] == null) {
      if (isRequired) {
        throw new Error(
          `Required \`${propName}\` was not specified in ${componentName}.`
        );
      }
      return null;
    } else {
      return validate(props, propName, componentName);
    }
  };

  const chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
